import { render, staticRenderFns } from "./studios.vue?vue&type=template&id=0401b85e&scoped=true&"
import script from "./studios.vue?vue&type=script&lang=js&"
export * from "./studios.vue?vue&type=script&lang=js&"
import style0 from "./studios.vue?vue&type=style&index=0&id=0401b85e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0401b85e",
  null
  
)

export default component.exports